import React from 'react';
import { Outlet, Route, Routes, useLocation } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core/styles';

import CompleteDocumentClaim from '@bizapp-lp/pjb/pages/CompleteDocumentClaim';
import CompleteContact from '@bizapp-lp/pjb/pages/CompleteContact';
import CompleteTrialApplication from '@bizapp-lp/pjb/pages/CompleteTrialApplication';
import Invalid from '@bizapp-lp/pjb/pages/Invalid';
import ServiceSpec01 from '@bizapp-lp/pjb/pages/specs/ServiceSpec0120210713';
import ServiceSpec02 from '@bizapp-lp/pjb/pages/specs/ServiceSpec0220211223';
import ServiceSpec03 from '@bizapp-lp/pjb/pages/specs/ServiceSpec0320220318';
import ServiceSpec04 from '@bizapp-lp/pjb/pages/specs/ServiceSpec0420220629';
import ServiceSpec05 from '@bizapp-lp/pjb/pages/specs/ServiceSpec0520230401';
import TrialSpec01 from '@bizapp-lp/pjb/pages/specs/TrialSpec0120210713';
import TrialSpec02 from '@bizapp-lp/pjb/pages/specs/TrialSpec0220211223';
import TrialSpec03 from '@bizapp-lp/pjb/pages/specs/TrialSpec0320220318';

import Sitemap from '@bizapp-lp/pjb/pages/internal/Sitemap';

import { theme } from '@bizapp-lp/pjb/styles/theme';

interface RedirectProps {
  to?: string;
}

const Redirect: React.FC<RedirectProps> = ({ to }) => {
  React.useEffect(() => {
    window.location.href = to ?? 'https://www.worksap.co.jp/saas/projectboard';
  }, [to]);
  return <></>;
};

const App: React.FC = () => {
  const { hash, pathname } = useLocation();

  React.useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [hash, pathname]);

  return (
    <ThemeProvider theme={theme}>
      <Routes basename="/pjb">
        <Route
          path="/complete-contact"
          element={<CompleteContact isAllowedDirectAccess />}
        />
        <Route
          path="/complete-document-claim"
          element={<CompleteDocumentClaim isAllowedDirectAccess />}
        />
        <Route
          path="/complete-trial-application"
          element={<CompleteTrialApplication />}
        />
        <Route
          path="/contact"
          element={<Redirect to="https://www.worksap.co.jp/contact/" />}
        />
        <Route
          path="/document-claim"
          element={
            <Redirect to="https://www.worksap.co.jp/saas/projectboard/#form" />
          }
        />
        <Route
          path="/trial-application"
          element={
            <Redirect to="https://customer.bizapp.worksap.co.jp/signup/pjb" />
          }
        />

        <Route path="/invalid" element={<Invalid />} />
        <Route path="/internal">
          <Route path="/sitemap" element={<Sitemap />} />
          <Route path="*" element={<Sitemap />} />
          <Route path="" element={<Sitemap />} />
        </Route>
        <Route
          path="/service-spec"
          element={
            <Redirect to="https://www.worksap.co.jp/services/spec/pjb-spec/" />
          }
        />
        <Route
          path="/trial-spec"
          element={
            <Redirect to="https://www.worksap.co.jp/terms/saas/projectboard/trial/latest.html" />
          }
        />
        <Route
          path="/spec-archive"
          element={
            <>
              <Outlet />
            </>
          }
        >
          <Route path="/service-spec-01-20210713" element={<ServiceSpec01 />} />
          <Route path="/service-spec-02-20211223" element={<ServiceSpec02 />} />
          <Route path="/service-spec-03-20220318" element={<ServiceSpec03 />} />
          <Route path="/service-spec-04-20220629" element={<ServiceSpec04 />} />
          <Route path="/service-spec-05-20230401" element={<ServiceSpec05 />} />
          <Route path="/trial-spec-01-20210713" element={<TrialSpec01 />} />
          <Route path="/trial-spec-02-20211223" element={<TrialSpec02 />} />
          <Route path="/trial-spec-03-20220318" element={<TrialSpec03 />} />
        </Route>
        <Route
          path="*"
          element={
            <Redirect to="https://www.worksap.co.jp/services/spec/pjb-spec/" />
          }
        />
      </Routes>
    </ThemeProvider>
  );
};

export default App;
